'use client';

import { Button, ButtonProps } from '@heroui/button';
import Link from 'next/link';
import React from 'react';

type NextUiButtonLinkProps = ButtonProps & {
  href: string;
  classNames?: {
    button?: string;
    link?: string;
  };
};

export default function NextUiButtonLink(props: NextUiButtonLinkProps) {
  const { href, classNames, children, target, rel, ...rest } = props;

  if (props.isDisabled) {
    return (
      <Button {...rest} className={classNames?.button + ' font-bold uppercase'}>
        {children}
      </Button>
    );
  }

  // Use the recommended HeroUI pattern with 'as' prop instead of nesting
  return (
    <Button
      as={Link}
      href={href}
      target={target}
      rel={rel}
      {...rest}
      className={`${classNames?.button || ''} ${
        classNames?.link || ''
      } font-bold uppercase`.trim()}
    >
      {children}
    </Button>
  );
}
